import { type FC, type MouseEvent } from "react";
import { AcceptScoutLink } from "@userFrontend/components/Links/AcceptScoutLink";
import { EntryLink } from "@userFrontend/components/Links/EntryLink";
import { Button } from "@root/shared/components/Button";
import { type EntryButtonSectionProps } from "../../types";

/**
 * 応募ボタンセクション
 * 応募状態に応じて適切なボタンを表示する
 */
export const EntryButtonSection: FC<EntryButtonSectionProps> = ({
  hasEntried,
  scoutForWork,
  enterableFlag,
  entryUrl,
  scoutEntryUrl,
  workCode,
  entryTracking,
  scoutTracking,
  queryString,
  onClickLink,
}) => {
  if (hasEntried) {
    return <Button theme="disabled">応募済み</Button>;
  }

  if (scoutForWork) {
    return (
      <AcceptScoutLink
        text="スカウトを受ける"
        className="ga-click js-webhook"
        url={scoutEntryUrl ?? ""}
        gaAction={scoutTracking.gaAction}
        gaLabel={scoutTracking.gaLabel}
        workCode={workCode}
        clientShopId={scoutForWork.clientShopId ?? undefined}
      />
    );
  }

  if (enterableFlag) {
    return (
      <EntryLink
        text="応募する"
        className="ga-click"
        url={entryUrl}
        gaAction={entryTracking.gaAction}
        gaLabel={entryTracking.gaLabel}
        firebaseAction={entryTracking.firebaseAction}
        firebaseActionType={entryTracking.firebaseActionType}
        firebaseEventGeneratedPart={entryTracking.firebaseEventGeneratedPart}
        onClick={(event: MouseEvent<HTMLAnchorElement>) => {
          onClickLink({
            url: entryUrl,
            query: queryString ?? "",
            event,
          });
        }}
      />
    );
  }

  return <Button theme="disabled">募集停止</Button>;
};
